import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../box/src";
export const BlurredBackground = (_a) => {
    var { fadeTo, fallbackUrl, height = '450px', imageUrl, width = '100%' } = _a, otherProps = __rest(_a, ["fadeTo", "fallbackUrl", "height", "imageUrl", "width"]);
    return (_jsx(Box, { alignSelf: "stretch", "data-testid": "blurred-background", height: 0, children: _jsxs(BackgroundImageCropper, Object.assign({ height: height, width: width }, otherProps, { children: [_jsx(BlurredImage, { alt: "", as: "img", onError: (e) => {
                        if (fallbackUrl) {
                            e.currentTarget.src = fallbackUrl;
                        }
                    }, src: imageUrl }), _jsx(WhiteOverlay, {}), fadeTo && (_jsx(FadingBox, { "$fadeTo": fadeTo, "data-testid": "fading-box", height: height, width: "100%" }))] })) }));
};
const BackgroundImageCropper = styled(Box) `
  position: relative;
  overflow: hidden;
`;
const BlurredImage = styled(Box).attrs(() => ({
    height: '100%',
    width: '100%',
})) `
  object-fit: cover;
  filter: blur(28px);
  /* Applying a small scale ensures cleaner edges (see http://volkerotto.net/2014/07/03/css-background-image-blur-without-blury-edges/) */
  transform: scale(1.07);
`;
const WhiteOverlay = styled(Box).attrs(() => ({
    bg: 'white',
    height: '100%',
    width: '100%',
})) `
  position: absolute;
  top: 0;
  filter: opacity(19%);
`;
const FadingBox = styled(Box) `
  position: absolute;
  top: 0;
  background-image: linear-gradient(
    to bottom,
    var(--color-background-transparent, rgba(0, 0, 0, 0)),
    ${({ $fadeTo }) => $fadeTo}
  );
`;
//# sourceMappingURL=BlurredBackground.js.map